import { Component } from '@angular/core';
import { Toast, ToastPackage, ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { NotificationSocket } from '@shared/services/websocket/custom_sockets/notification.socket';
import { NotificationsEnum } from '../../../@features/notifications/enums/notifications.enum';
import { RedirectLink } from '@shared/models/notifications.model';

@Component({
  selector: 'app-notification',
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.scss'],
})
export class NotificationComponent extends Toast {
  constructor(
    toastrService: ToastrService,
    toastPackage: ToastPackage,
    private router: Router,
    private notificationSocket: NotificationSocket
  ) {
    super(toastrService, toastPackage);
  }

  public goTo(): void {
    const trade_link = this.options.payload.redirect_links.find(
      (itm: RedirectLink) => itm.type === NotificationsEnum.TRADE
    );
    const order_link = this.options.payload.redirect_links.find(
      (itm: RedirectLink) => itm.type === NotificationsEnum.ORDER
    );
    const offer_link = this.options.payload.redirect_links.find(
      (itm: RedirectLink) => itm.type === NotificationsEnum.OFFER
    );
    const chat = this.options.payload.redirect_links.find(
      (itm: RedirectLink) => itm.type === NotificationsEnum.CHAT
    );
    if (trade_link?.id && offer_link?.id) {
      if (trade_link.status === 'owner') {
        this.router.navigate([
          'sales-orders/my-orders',
          trade_link?.id,
          'offer',
          offer_link?.id,
        ]);
      } else if (offer_link.status === 'owner') {
        this.router.navigate(['sales-orders/my-offers', offer_link?.id]);
      }
    }
    if (trade_link?.id && !offer_link?.id) {
      this.router.navigate(['sales-orders', 'list', trade_link?.id]);
    }
    if (order_link?.id && offer_link?.id) {
      if (order_link.status == 'owner') {
        this.router.navigate([
          'purchase-orders/my-orders',
          order_link?.id,
          'offer',
          offer_link?.id,
        ]);
      } else if (offer_link.status === 'owner') {
        this.router.navigate(['purchase-orders/my-offers', offer_link?.id]);
      }
    }
    if (order_link?.id && !offer_link?.id) {
      this.router.navigate(['purchase-orders', 'list', order_link?.id]);
    }
    if (chat) {
      this.router.navigate(['chat'], { queryParams: { id: chat.id } });
    }
    if (this.options.payload.category === 'chat') {
      this.router.navigate(['chat']);
    }
    this.notificationSocket.emit(
      'markNotificationAsReaded',
      this.options.payload._id,
      'notification'
    );
  }
}
